export default function Features() {
  const features = [
    {
      icon: 'ri-stack-line',
      title: '智能盘垛与库存管理',
      description: '激光雷达快速扫描散货堆场,自动计算体积和重量,盘点时间从天缩短至小时',
      metrics: [
        { label: '精度', value: '±2%' },
        { label: '效率提升', value: '300%' }
      ],
      image: 'https://public.readdy.ai/ai/img_res/53a395a284bee092214e935ead9832b4.jpg'
    },
    {
      icon: 'ri-ship-line',
      title: '船舶进出港辅助',
      description: '海上视角实时画面传输,辅助拖轮和引航员操作,提升大型船舶靠泊安全性',
      metrics: [
        { label: '事故率降低', value: '85%' },
        { label: '靠泊效率', value: '+40%' }
      ],
      image: 'https://readdy.ai/api/search-image?query=aerial%20drone%20view%20of%20large%20cargo%20ship%20docking%20at%20port%20terminal%2C%20tugboat%20assistance%20perspective%2C%20real-time%20navigation%20overlay%20with%20distance%20markers%2C%20maritime%20safety%20monitoring%2C%20professional%20harbor%20operations%2C%20blue%20ocean%20background&width=600&height=400&seq=feature-002&orientation=landscape'
    },
    {
      icon: 'ri-water-flash-line',
      title: '水尺计重系统',
      description: '海空两栖无人机快速抵达船舷,观测吃水深度计算货物重量,替代传统人工方式',
      metrics: [
        { label: '测量时间', value: '&lt;15min' },
        { label: '风险降低', value: '90%' }
      ],
      image: 'https://readdy.ai/api/search-image?query=amphibious%20drone%20measuring%20ship%20draft%20marks%20on%20vessel%20hull%2C%20water%20level%20detection%20system%2C%20maritime%20cargo%20weight%20calculation%2C%20floating%20drone%20on%20ocean%20surface%20near%20ship%20side%2C%20technical%20measurement%20interface%20overlay&width=600&height=400&seq=feature-003&orientation=landscape'
    },
    {
      icon: 'ri-shield-check-line',
      title: '全天候安防巡逻',
      description: '24小时自动巡检,识别劳保穿戴、明火烟雾、违规闯入,实时喊话干预',
      metrics: [
        { label: '覆盖范围', value: '50km²' },
        { label: '响应时间', value: '&lt;3min' }
      ],
      image: 'https://readdy.ai/api/search-image?query=security%20drone%20patrolling%20port%20at%20night%20with%20thermal%20imaging%2C%20infrared%20heat%20detection%20view%20of%20harbor%20facilities%2C%20automated%20surveillance%20system%2C%20safety%20monitoring%20with%20alert%20markers%2C%20dark%20blue%20night%20scene%20with%20glowing%20sensors&width=600&height=400&seq=feature-004&orientation=landscape'
    },
    {
      icon: 'ri-leaf-line',
      title: '环境监测网络',
      description: '监测港区海域悬浮物、油污、粉尘排放,实时数据上传环保平台',
      metrics: [
        { label: '监测点位', value: '120+' },
        { label: '数据精度', value: '99.5%' }
      ],
      image: 'https://readdy.ai/api/search-image?query=environmental%20monitoring%20drone%20over%20port%20waters%2C%20air%20quality%20sensors%20detecting%20pollution%2C%20water%20quality%20analysis%20visualization%2C%20eco-friendly%20harbor%20management%2C%20green%20technology%20with%20data%20overlay%2C%20clean%20ocean%20and%20sky%20background&width=600&height=400&seq=feature-005&orientation=landscape'
    },
    {
      icon: 'ri-tools-line',
      title: '设施无人化巡检',
      description: '岸桥、场桥、高架桥、输油管道高空巡检,识别结构裂纹、螺栓松动等隐患',
      metrics: [
        { label: '巡检效率', value: '+500%' },
        { label: '隐患发现', value: '+200%' }
      ],
      image: 'https://readdy.ai/api/search-image?query=inspection%20drone%20examining%20large%20port%20crane%20structure%2C%20close-up%20of%20industrial%20equipment%20maintenance%2C%20crack%20detection%20AI%20analysis%2C%20high-altitude%20facility%20inspection%2C%20technical%20diagnostic%20overlay%20with%20measurement%20data&width=600&height=400&seq=feature-006&orientation=landscape'
    }
  ];

  return (
    <section id="features" className="py-24 bg-gradient-to-b from-[#0d1b2a] to-[#1a1a2e]">
      <div className="max-w-7xl mx-auto px-6">
        {/* 标题 */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-4 mb-4">
            <div className="h-px w-12 bg-teal-500"></div>
            <span className="text-teal-400 text-sm tracking-widest font-light">CORE CAPABILITIES</span>
            <div className="h-px w-12 bg-teal-500"></div>
          </div>
          <h2 className="text-5xl md:text-6xl font-black text-white mb-4">
            全域智能感知能力矩阵
          </h2>
          <p className="text-xl text-gray-400">
            覆盖生产运营、安全应急、环境维保三大维度
          </p>
        </div>

        {/* 功能卡片网格 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-[#141e30]/60 border border-teal-500/30 rounded-lg p-6 hover:border-teal-500 hover:-translate-y-2 transition-all duration-300 hover:shadow-lg hover:shadow-teal-500/20 cursor-pointer"
            >
              {/* 图片 */}
              <div className="w-full h-48 mb-6 rounded-lg overflow-hidden">
                <img 
                  src={feature.image} 
                  alt={feature.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
              </div>

              {/* 图标 */}
              <div className="w-16 h-16 flex items-center justify-center mb-4">
                <i className={`${feature.icon} text-4xl text-teal-400`}></i>
              </div>

              {/* 标题 */}
              <h3 className="text-xl font-bold text-white mb-3">
                {feature.title}
              </h3>

              {/* 描述 */}
              <p className="text-gray-400 text-sm leading-relaxed mb-4">
                {feature.description}
              </p>

              {/* 数据标签 */}
              <div className="flex gap-3">
                {feature.metrics.map((metric, idx) => (
                  <div key={idx} className="px-3 py-1 bg-teal-500/10 border border-teal-500/30 rounded-full">
                    <span className="text-xs text-teal-400">
                      {metric.label}: <strong dangerouslySetInnerHTML={{ __html: metric.value }}></strong>
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}